import styled from "styled-components";

const StyledNumberInput = styled.input`
    border: solid 1px ${(props) => props.theme.color.bordergray};
    color: ${(props) => props.theme.color.dark};
    font-family: ${(props) => props.theme.fonts.SegoeUI};
    box-sizing: border-box;
    border-radius: 2px;
    
    ::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
        color: ${(props) => props.theme.color.disabledgray};
        opacity: 1; /* Firefox */
    }

    :-ms-input-placeholder { /* Internet Explorer 10-11 */
        color: ${(props) => props.theme.color.disabledgray};
    }

    ::-ms-input-placeholder { /* Microsoft Edge */
        color: ${(props) => props.theme.color.disabledgray};
    }

    :focus {
        outline: none !important;
        border:2px solid ${(props) => props.validated === undefined ? props.theme.color.primaryblue : ''};
    }

    :disabled {
        outline: none !important;
        border: solid 1px ${(props) => props.theme.color.bordergray};
        color: ${(props) => props.theme.color.gray};
        background-color: ${(props) => props.theme.color.disabledgray}
    }

    ${({ validated }) => validated === false && `
        border-color: #dc3545;
        color: #dc3545;
    `}

    ${({ validated }) => validated === true && `
        border-color: #198754;
        color: #198754;
    `}

    ::-webkit-appearance: textfield;
    ::-moz-appearance: textfield;
    ::appearance: textfield;

    ::-webkit-inner-spin-button, ::-webkit-outer-spin-button { 
        -webkit-appearance: none;
    }
`;

const StyledSpinnerUp = styled.button`
    display: block;
    background-color: ${(props) => props.theme.color.gray};
    border: none;
    border-radius: 2px;
    width: 13px;
    height: 8px;
    margin-left: -19px;
    cursor: pointer;
    margin-bottom: 5px;

    background: ${(props) => props.theme.color.gray} url("data:image/svg+xml;utf8,<svg viewBox='0 0 140 140' width='10' height='10' xmlns='http://www.w3.org/2000/svg'><g><path d='m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z' fill='${(props) => props.isMenuOpened ? 'black' : 'white'}'/></g></svg>") no-repeat;
    background-position: right 1px top 52%;
    
    transform: rotate(180deg);

    :active {
        transform: scale(1.1) rotate(180deg);
        background-position: right 1px top 52%;
    }
`;

const StyledSpinnerDown = styled.button`
    display: block;
    background-color: ${(props) => props.theme.color.gray};
    border: none;
    border-radius: 2px;
    width: 13px;
    height: 8px;
    margin-left: -19px;
    cursor: pointer;

    background: ${(props) => props.theme.color.gray} url("data:image/svg+xml;utf8,<svg viewBox='0 0 140 140' width='10' height='10' xmlns='http://www.w3.org/2000/svg'><g><path d='m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z' fill='${(props) => props.isMenuOpened ? 'black' : 'white'}'/></g></svg>") no-repeat;
    background-position: right 1px top 52%;
    
    :active {
        transform: scale(1.1);
        background-position: right 1px top 52%;
    }
`;

function NumberInput(props) {

    const {onPressEnter, onChange, ...restProps} = props;

    const onKeyPress = (e) => {
        if (e.charCode === 13 && onPressEnter) {
            onPressEnter();
        }
    }
    
    const setNativeValue = (element, value) => {
        const valueSetter = Object.getOwnPropertyDescriptor(element, 'value').set;
        const prototype = Object.getPrototypeOf(element);
        const prototypeValueSetter = Object.getOwnPropertyDescriptor(
            prototype,
            'value'
        ).set;

        if (valueSetter && valueSetter !== prototypeValueSetter) {
            prototypeValueSetter.call(element, value);
        } else {
            valueSetter.call(element, value);
        }
    };

    const handleClickUp = (e) => {
        let targetInput = e.target.parentNode.parentNode.getElementsByTagName('input')[0];
        let max = targetInput.getAttribute('max');
        let oldVal = parseInt(targetInput.value);
        let newVal = max ? Math.min(oldVal + 1, max) : (oldVal + 1);
        var event = new Event("input", { bubbles: true });

        setNativeValue(targetInput, newVal);
        targetInput.dispatchEvent(event);
        targetInput.focus();
    }

    const handleClickDown = (e) => {
        let targetInput = e.target.parentNode.parentNode.getElementsByTagName('input')[0];
        let min = targetInput.getAttribute('min');
        let oldVal = parseInt(targetInput.value);
        let newVal = min ? Math.max(oldVal - 1, min) : (oldVal - 1);
        var event = new Event("input", { bubbles: true });

        setNativeValue(targetInput, newVal);
        targetInput.dispatchEvent(event);
        targetInput.focus();
    }

    const onChangeNumber = (e) => {
        if (e.target.value === '') {
            e.target.value = 0;
        }
        onChange(e);
    }

    return (
        <div style={{display: 'flex'}}>
        <StyledNumberInput type='number' onKeyPress={onKeyPress} onChange={(e) => onChangeNumber(e)} {...restProps}></StyledNumberInput>
        <div style={{marginTop: 'auto', marginBottom: 'auto'}}>
            <StyledSpinnerUp onClick={handleClickUp}></StyledSpinnerUp>
            <StyledSpinnerDown onClick={handleClickDown}></StyledSpinnerDown>
        </div>
        </div>
    )
}

export default NumberInput;